/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FilestoreInfo } from './FilestoreInfo';
import {
    FilestoreInfoFromJSON,
    FilestoreInfoFromJSONTyped,
    FilestoreInfoToJSON,
} from './FilestoreInfo';

/**
 * 
 * @export
 * @interface FilestoreAttachment
 */
export interface FilestoreAttachment {
    /**
     * 
     * @type {number}
     * @memberof FilestoreAttachment
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof FilestoreAttachment
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof FilestoreAttachment
     */
    path?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FilestoreAttachment
     */
    input?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilestoreAttachment
     */
    output?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilestoreAttachment
     */
    primary?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilestoreAttachment
     */
    scheduler?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilestoreAttachment
     */
    worker?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FilestoreAttachment
     */
    complete: boolean;
    /**
     * 
     * @type {FilestoreInfo}
     * @memberof FilestoreAttachment
     */
    filestore: FilestoreInfo;
}

/**
 * Check if a given object implements the FilestoreAttachment interface.
 */
export function instanceOfFilestoreAttachment(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "complete" in value;
    isInstance = isInstance && "filestore" in value;

    return isInstance;
}

export function FilestoreAttachmentFromJSON(json: any): FilestoreAttachment {
    return FilestoreAttachmentFromJSONTyped(json, false);
}

export function FilestoreAttachmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilestoreAttachment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'input': !exists(json, 'input') ? undefined : json['input'],
        'output': !exists(json, 'output') ? undefined : json['output'],
        'primary': !exists(json, 'primary') ? undefined : json['primary'],
        'scheduler': !exists(json, 'scheduler') ? undefined : json['scheduler'],
        'worker': !exists(json, 'worker') ? undefined : json['worker'],
        'complete': json['complete'],
        'filestore': FilestoreInfoFromJSON(json['filestore']),
    };
}

export function FilestoreAttachmentToJSON(value?: FilestoreAttachment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'path': value.path,
        'input': value.input,
        'output': value.output,
        'primary': value.primary,
        'scheduler': value.scheduler,
        'worker': value.worker,
        'complete': value.complete,
        'filestore': FilestoreInfoToJSON(value.filestore),
    };
}

